import { makeObservable, observable } from "mobx";

class OptionsModel {
  showOptions: boolean
  optionsRef: React.Ref<HTMLDivElement> | null = null
  optionsBtnRef: React.Ref<HTMLDivElement> | null = null;
  constructor() {
    this.showOptions = false;
    makeObservable(this, {
      showOptions: observable,
    })
  }
}

const OptionsModelEntity = new OptionsModel();

export default OptionsModelEntity;
